// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"348":"update","388":"result","400":"bonuses","519":"bulk-absent","687":"create","697":"data-delete","715":"list"}[chunkId] || chunkId) + "." + {"348":"c2127d7f","388":"273b21fa","400":"8d7d4b53","519":"a2ba8bbe","687":"d5363854","697":"cd524c51","715":"184196ed","716":"6f48705a","807":"5b94e0ea"}[chunkId] + ".js";
};